import React from "react";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, RequireAuth, useAuth } from "../providers/AuthProvider";
import { QueryProvider } from "../providers/QueryProvider";
import { ToastContainer } from "../../ui/Toast";

import Login from "../../pages/Login";
import DashboardLayout from "../../pages/Dashboard/Layout";
import ClientsPage from "../../pages/Clients";
import CompanyDetailPage from "../../pages/Company/Detail";
import LogsPage from "../../pages/Logs";
import SandboxPage from "../../pages/Sandbox";

/**
 * AppRouter
 *
 * CSR-only routing using HashRouter (per BLUEPRINT.md) to avoid server rewrites.
 *
 * Routes:
 * - /#/login
 * - /#/ -> redirect to /#/clients if authed else /#/login
 * - Protected:
 *   - /#/clients
 *   - /#/logs
 *   - /#/sandbox
 */
export function AppRouter() {
  return (
    <QueryProvider>
      <AuthProvider>
        {/* Toast UI (Flowbite-style, brand-themed) */}
        <ToastContainer position="top-right" />

        <HashRouter>
          <Routes>
            <Route path="/" element={<IndexRedirect />} />
            <Route path="/login" element={<Login />} />

            <Route element={<RequireAuth />}>
              <Route element={<DashboardLayout />}>
                <Route path="/company" element={<ClientsPage />} />
                <Route
                  path="/company/:companyId"
                  element={<CompanyDetailPage />}
                />
                <Route path="/logs" element={<LogsPage />} />
                <Route path="/sandbox" element={<SandboxPage />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </HashRouter>
      </AuthProvider>
    </QueryProvider>
  );
}

function IndexRedirect() {
  const auth = useAuth();
  return <Navigate to={auth.isAuthenticated ? "/company" : "/login"} replace />;
}
